const exclamation = '!'; // Or whatever symbol you use

const patterns = [
  { pattern: /\b(\d{5})\d{5}\b/g, replacement: `$1xxxxx ${exclamation}` },
  { pattern: /\b(\d{5}) (\d{5})\b/g, replacement: `$1 xxxxx ${exclamation}` },
  { 
    pattern: /\b(\d{1}) (\d{1}) (\d{1}) (\d{1}) (\d{1}) (\d{1}) (\d{1}) (\d{1}) (\d{1}) (\d{1})\b/g, 
    replacement: `$1 $1 $1 $1 $1 x x x x x ${exclamation}` 
  },
  { pattern: /\b(\d{2}) (\d{5}) (\d{5})\b/g, replacement: `xx $1 xxxxx ${exclamation}` },
  { pattern: /\b(\d{2}) (\d{10})\b/g, replacement: `xx $1xxxxx ${exclamation}` },
  { pattern: /\b(\d{3}) (\d{1})(\d{1})(\d{1}) (\d{4})\b/g, replacement: `$1 $2$3x xxxx ${exclamation}` },
  { pattern: /\b(\d{3})(\d{1})(\d{1})(\d{1}) (\d{4})\b/g, replacement: `$1$2$3x xxxx${exclamation}` },
  { 
    pattern: /\b(\d{1})[^\d](\d{1})[^\d](\d{1})[^\d](\d{1})[^\d](\d{1})[^\d](\d{1})[^\d](\d{1})[^\d](\d{1})[^\d](\d{1})[^\d]*(\d{1})\b/g, 
    replacement: `$1 $2 $3 $4 $5 x x x x x ${exclamation}` 
  },
];

// Function to apply all patterns
export function obfuscateSensitiveNumbers(text) {
  return patterns.reduce((acc, { pattern, replacement }) => {
    return acc.replace(pattern, replacement);
  }, text);
}
